import { ComponentPropsWithoutRef } from 'react';
import { IonButton, IonToolbar } from '@ionic/react';
import classnames from 'classnames';
import ProfileIcon from '../../assets/icons/ProfileIcon';
import { Modals } from '../../../mobile/exports/Enums';
import useModalRouter from '../../common/hooks/useModalRouter';

type ProfileToolbarProps = ComponentPropsWithoutRef<typeof IonToolbar>;

const ProfileToolbar = ({ className, ...rest }: ProfileToolbarProps) => {
  const { openModal } = useModalRouter();

  const onClick = (): void => openModal({ id: Modals.Profile });

  return (
    <IonToolbar
      className={classnames(
        'ion-color w-fit ml-auto stroke-white !p-0 [&::part(container)]:min-h-none [&::part(container)]:p-0',
        className,
      )}
      style={{
        '--border-style': 'none',
      }}
      {...rest}
    >
      <IonButton fill="clear" className="[&::part(native)]:!p-0 min-h-6 h-6 m-0" slot="end" onClick={onClick}>
        <ProfileIcon />
      </IonButton>
    </IonToolbar>
  );
};

export default ProfileToolbar;
